<div class="container container-e-service-request">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <section
      class="card mb-4"
      [ngClass]="
        !isInvestorDetailsFormGroupValid() && submitted
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.INVESTOR_DETAILS.TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <app-investor-details
          [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
        ></app-investor-details>
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-proxy-details>

    <section
      class="card mb-4"
      [ngClass]="
        checkDecisionFormControlsValidAndFormValidated()
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.CONSTRUCTION_LOG_REQUEST'
            | translate
        }}
      </div>

      <div class="card-body">
        <div class="row">
          <div class="form-group col-md-4">
            <label [attr.for]="controlName.DecisionNumber">
              {{
                'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.DECISION_NUMBER'
                  | translate
              }}
            </label>

            <input
              type="text"
              [name]="controlName.DecisionNumber"
              [id]="controlName.DecisionNumber"
              class="form-control form-control-sm required"
              aria-required="true"
              [formControlName]="controlName.DecisionNumber"
            />

            @if (shouldShowRequiredAlert(this.getDecisionNumberFormControl())) {
              <div class="alert alert-danger">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>

          <div class="form-group col-md-4">
            <label [attr.for]="controlName.DecisionNumber">
              {{
                'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.DECISION_DATE'
                  | translate
              }}
            </label>

            <div class="input-group">
              <input
                class="form-control form-control-sm required"
                aria-required="true"
                [attr.placeholder]="
                  'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate
                "
                [id]="controlName.DecisionDate"
                [name]="controlName.DecisionDate"
                [formControlName]="controlName.DecisionDate"
                ngbDatepicker
                #d="ngbDatepicker"
              />

              <button
                class="btn btn-outline-secondary fa fa-calendar"
                (click)="d.toggle()"
                type="button"
              ></button>
            </div>

            @if (shouldShowRequiredAlert(this.getDecisionDateFormControl())) {
              <div class="alert alert-danger">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>

          <div class="form-group col-md-4">
            <label [attr.for]="controlName.DecisionPublishedBy">
              {{
                'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.DECISION_PUBLISHED_BY'
                  | translate
              }}
            </label>

            <input
              type="text"
              [name]="controlName.DecisionPublishedBy"
              [id]="controlName.DecisionPublishedBy"
              class="form-control form-control-sm required"
              aria-required="true"
              [formControlName]="controlName.DecisionPublishedBy"
            />

            @if (
              shouldShowRequiredAlert(this.getDecisionPublishedByFormControl())
            ) {
              <div class="alert alert-danger">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>
        </div>
      </div>
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        checkConstructionLogTypeFormControlValidAndFormValidated()
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <label
        class="card-header text-white bg-dark"
        [attr.for]="controlName.ConstructionLogType"
      >
        {{
          'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.CONSTRUCTION_LOG_TYPE'
            | translate
        }}
      </label>

      <div class="card-body">
        <select
          [name]="controlName.ConstructionLogType"
          [id]="controlName.ConstructionLogType"
          [formControlName]="controlName.ConstructionLogType"
          class="form-select form-select-sm required"
          aria-required="true"
        >
          <option [ngValue]="null" hidden selected>
            {{
              'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.AGRICULTURAL_LAND_USE_REQUEST.PLACEHOLDERS.SELECT'
                | translate
            }}
          </option>

          <option [ngValue]="constructionLogType.DB1">
            {{ 'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.DR1' | translate }}
          </option>

          <option [ngValue]="constructionLogType.DB2">
            {{ 'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.DR2' | translate }}
          </option>

          <option [ngValue]="constructionLogType.DB2_A">
            {{
              'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.DR2_A' | translate
            }}
          </option>

          <option [ngValue]="constructionLogType.DB3">
            {{ 'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.DR3' | translate }}
          </option>
        </select>
      </div>
    </section>

    <app-authorized-person
      [submitted]="submitted"
      [parentForm]="getAuthorizedDetailsFormGroup()"
    ></app-authorized-person>

    <gk-attachments
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-request-reply-form>

    <button type="submit" class="btn btn-primary">
      {{
        'CONSTRUCTION_PORTAL.CONSTRUCTION_LOG.FIELDS.SUBMIT_REQUEST' | translate
      }}
    </button>

    <app-doc-sign-info
      [messageText]="docSignMsgTxt"
      [messageType]="docSignMsgType"
      [docSignUrl]="docSignUrl"
      [docSignPending]="docSignPending"
    ></app-doc-sign-info>

    <div class="mt-2"><app-form-legend></app-form-legend></div>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
